module.exports = __webpack_public_path__ + "media/base/vendor_truck_big-e7f8d389.svg";